"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlService = void 0;
/* eslint-disable no-prototype-builtins */
const webexUI_1 = require("webexUI");
const PLUS_SING_ENCODED_EXP = /%2B/gi;
const SPACE_SIGN_ENCODE_SYMBOL = '%20';
const WHITESPACE_CHARACTERS_EXP = /\s/g;
class UrlService {
    constructor() {
        // used only to read
        this.regexFileUrl = /^([\S]+)(\.(pdf|zip|dwg|dxf|((doc|ppt|xls)(x?))))(\?[\S]+)?$/i;
        this.matchExtension = /(\.(pdf|zip|dwg|dxf|((doc|ppt|xls)(x?))))(\?[\S]+)?$/i;
        this.CreateQueryObject = (pairs) => {
            return (0, webexUI_1.safe)(pairs).reduce((acc, next) => {
                if (!next.key) {
                    return acc;
                }
                return Object.assign(Object.assign({}, acc), { [next.key]: next.value });
            }, {});
        };
        this.isUrlParameterChanged = (obj) => {
            const urlObj = this.GetObjectFromUrlString();
            return !!this.isValueChanged(obj.value, urlObj[obj.key]);
        };
        this.isFilterSelected = (filter) => {
            const urlObject = this.GetObjectFromUrlString();
            return !(!urlObject.filter || urlObject.filter.indexOf(filter) === -1);
        };
        this.GetSourceUrl = () => {
            const location = window.location;
            const origin = location.origin ||
                `${location.protocol}//${location.hostname}${location.port ? ':' + location.port : ''}`;
            const isWindiwLocationSearch = window.location.search
                ? window.location.search
                : window.location.href.slice(window.location.href.indexOf('?'));
            let query = window.location.href.indexOf('?') === -1 ? '' : isWindiwLocationSearch;
            if (query.indexOf('#') !== -1) {
                query = query.slice(0, query.indexOf('#'));
            }
            return origin + window.location.pathname + query;
        };
        this.decodeFiltersForGTM = (filter) => {
            const decodedFilterParts = decodeURIComponent(filter).split(/[=:]/);
            const filterPartsCount = decodedFilterParts.length;
            if (filterPartsCount && filterPartsCount >= 2) {
                return {
                    filterCategory: decodedFilterParts[0],
                    filterOptions: decodedFilterParts[1],
                };
            }
            return null;
        };
        this.isValidUrl = (url) => {
            const pattern = new RegExp('^(https?:\\/\\/)?' +
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
                '((\\d{1,3}\\.){3}\\d{1,3}))' +
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
                '(\\?[;&a-z\\d%_.~+=-]*)?' +
                '(\\#[-a-z\\d_]*)?$', 'i');
            return !!pattern.test(url);
        };
        this.GetCultureAndLanguage = (url = window.location.href) => {
            const match = url.match(/\/([a-z]{2}-[a-z]{2})\//i) || url.match(/\/([a-z]{2})\//i);
            return match ? match[1] : null;
        };
        this.GetLanguage = (url = window.location.href) => {
            const match = url.match(/\/([a-z]{2})(?:-[a-z]{2})?\//i) || url.match(/\/([a-z]{2})\//i);
            return match ? match[1] : null;
        };
        this.isValueChanged = (value, previousValue) => {
            return ((!previousValue && !!value) || // added new value
                (previousValue && previousValue !== value)); // page value changed
        };
        this.correctEncodeDiffBetweenFEandBE = (value) => {
            let result = value;
            if (value) {
                result = value.replace(PLUS_SING_ENCODED_EXP, SPACE_SIGN_ENCODE_SYMBOL);
            }
            return result;
        };
    }
    GetObjectFromUrlString(url = window.location.search) {
        if (url.length === 0 || url.indexOf('=') === -1) {
            return {};
        }
        else {
            const arr = url.slice(1, url.length).split('&');
            const obj = {};
            for (const item of arr) {
                let itemValue = item.split('=')[1];
                // Added for supporting old urls
                itemValue = this.correctEncodeDiffBetweenFEandBE(itemValue);
                obj[item.split('=')[0]] = decodeURIComponent(itemValue);
            }
            return obj;
        }
    }
    GetStringFromUrlObj(obj) {
        let str = `?`;
        for (const i in obj) {
            str += `${i}=${encodeURIComponent(obj[i])}&`;
        }
        return str.slice(0, -1);
    }
    IsUrlHasQueryKey(key, url = window.location.search) {
        if (url.length === 0 || url.indexOf('=') === -1) {
            false;
        }
        else {
            const urlParams = new URLSearchParams(url);
            return urlParams.has(key);
        }
    }
    GetQueryValueFromUrl(key, url = window.location.search) {
        const urlParams = new URLSearchParams(url);
        if (this.IsUrlHasQueryKey(key, url)) {
            return urlParams.get(key);
        }
        return '';
    }
    GetFilterQueryValueFromUrl(key) {
        const keyValueArray = this.GetQueryValueFromUrl('filter').split(',');
        const value = keyValueArray.reduce((acc, pair) => {
            const [key, value] = pair.split(':');
            acc[key] = value;
            return acc;
        }, {})[key];
        if (!value) {
            return '';
        }
        return value;
    }
    GetQueryObjectValueFromUrl(key) {
        const keyValueString = this.GetQueryValueFromUrl(key);
        if (!keyValueString) {
            return {};
        }
        const keyValueArray = keyValueString.split(',');
        return keyValueArray.reduce((acc, pair) => {
            const [key, value] = pair.split(':');
            acc[key] = value;
            return acc;
        }, {});
    }
    // Returns true if state was pushed
    AddToUrl(obj, replace = true) {
        if (!obj.value) {
            return this.RemoveFromUrl(obj.key, replace);
        }
        const urlObj = this.GetObjectFromUrlString();
        if (!this.isValueChanged(obj.value, urlObj[obj.key])) {
            return false;
        }
        urlObj[obj.key] = obj.value;
        const urlStr = this.GetStringFromUrlObj(urlObj);
        if (replace) {
            window.history.replaceState(urlObj, null, urlStr);
            return false;
        }
        else {
            window.history.pushState(urlObj, null, urlStr);
            return true;
        }
    }
    AddFilterToUrl(key) {
        if (!key) {
            return;
        }
        const prevFilter = this.GetObjectFromUrlString()['filter'];
        const newFilterValue = key + (prevFilter ? ',' + prevFilter : '');
        this.AddToUrl({
            key: 'filter',
            value: newFilterValue,
        });
    }
    RemoveFromUrl(key, replace = true) {
        // returns true if state was pushed
        const urlObj = this.GetObjectFromUrlString();
        // eslint-disable-next-line @typescript-eslint/ban-types
        if (!urlObj.hasOwnProperty(key)) {
            return false;
        }
        delete urlObj[key];
        const urlStr = this.GetStringFromUrlObj(urlObj);
        if (replace) {
            window.history.replaceState(urlObj, null, urlStr.length > 0 ? urlStr : document.location.pathname);
            return false;
        }
        else {
            window.history.pushState(urlObj, null, urlStr.length > 0 ? urlStr : document.location.pathname);
            return true;
        }
    }
    RemoveHash() {
        let url = window.location.href;
        if (url.includes('#')) {
            url = url.replace(/#.*$/, '');
            window.history.replaceState({}, document.title, url);
        }
    }
    CreateQueryCsv(pair) {
        return {
            key: pair.key,
            value: pair.value.join(','),
        };
    }
    ReplaceOrAddPairsOfKeyValuesInUrl(url, pairsOfKeysValues) {
        const urlObj = this.GetObjectFromUrlString(url);
        pairsOfKeysValues.forEach(({ key, value }) => {
            if (!!key && !!value) {
                urlObj[key] = value;
            }
        });
        return this.GetStringFromUrlObj(urlObj);
    }
    isUrlToFile(url, needWhiteSpacesEncoding = false) {
        if (url) {
            const urlToFile = needWhiteSpacesEncoding
                ? url.replace(WHITESPACE_CHARACTERS_EXP, SPACE_SIGN_ENCODE_SYMBOL)
                : url;
            return this.regexFileUrl.test(urlToFile);
        }
        return false;
    }
    GetFileExtension(url) {
        if (!url) {
            return null;
        }
        const ext = url.match(this.matchExtension);
        if (!ext || !ext.length) {
            return null;
        }
        return ext[2] || ext[1] || ext[0];
    }
}
const service = new UrlService();
exports.UrlService = service;
